export default __webpack_public_path__ + "icon_check.f8f5c53d5a49ab9336c1712a89ec316e.svg";